module.exports = __webpack_public_path__ + "img/menu1.15200d52.png";